<!-- eslint-disable catalyst/no-call-expression-with-args -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable catalyst/click-events-have-key-events -->
@let node = this.node();
@let templateForNode = this.templateForNode();
@let itemSize = node.children ? this.parentItemSize : this.childItemSize;
@let indentation = this.indentation();
@let isSelected = this.isSelected();
@let isSelectionDisabled = node.selectable === false;

<li
  [class]="`p-treenode overflow-hidden ${node.styleClass || ''}`"
  [class.p-treenode-leaf]="isNodeLeaf()"
  [style.height]="`${itemSize}px`"
  [style.max-height]="`${itemSize}px`"
  [style]="node.style"
  [style.position]="'relative'"
  [attr.aria-label]="node.label"
  [attr.aria-checked]="ariaChecked()"
  [attr.aria-setsize]="node.children ? node.children.length : 0"
  [attr.aria-selected]="ariaSelected()"
  [attr.aria-expanded]="node.expanded"
  [attr.aria-posinset]="index + 1"
  [attr.aria-level]="(level ?? 0) + 1"
  [attr.tabindex]="ignoreDefaultTabOrder ? -1 : index === 0 ? 0 : -1"
  [attr.data-id]="node.key"
  [class.treenode-droppoint-parent-active]="
    tree.droppableNodes() && draghoverNode() && canShowDropPointBetween()
  "
  [class.treenode-droppoint-item-active-next-between]="
    tree.droppableNodes() && draghoverNext() && canShowDropPointBetween()
  "
  role="treeitem"
  (keydown)="onKeyDown($event)"
>
  <div
    class="p-treenode-content"
    [class.p-treenode-selectable]="
      tree.selectionMode() && node.selectable !== false
    "
    [class.p-treenode-dragover]="
      draghoverNode() || draghoverPrev() || draghoverNext()
    "
    [class.treenode-droppoint-item-active-previous]="
      tree.droppableNodes() && draghoverPrev()
    "
    [class.treenode-droppoint-item-active-next]="
      tree.droppableNodes() && draghoverNode() && !canShowDropPointBetween()
    "
    [class.p-highlight]="isSelected"
    [style.padding-inline-start]="
      level !== undefined && indentation !== undefined
        ? `${level * indentation}rem`
        : undefined
    "
    (click)="onNodeClick($event)"
    (contextmenu)="onNodeRightClick($event)"
    (touchend)="onNodeTouchEnd()"
    (drop)="onDropNode($event)"
    (dragover)="onDropNodeDragOver($event)"
    (dragenter)="onDropNodeDragEnter($event)"
    (dragleave)="onDropNodeDragLeave($event)"
    [draggable]="tree.draggableNodes()"
    (dragstart)="onDragStart($event)"
    (dragend)="onDragStop($event)"
    [attr.tabindex]="ignoreDefaultTabOrder ? -1 : index === 0 ? 0 : -1"
  >
    <button
      type="button"
      [attr.data-pc-section]="'toggler'"
      class="p-tree-toggler p-link"
      [attr.aria-label]="node.expanded ? collapseText : expandText"
      (click)="toggle($event)"
      tabindex="-1"
    >
      @if (!tree.togglerIconTemplate()) {
        @if (!node.loading) {
          @if (!node.expanded) {
            <standard-icon
              [icon]="faChevronRight"
              styleClass="p-tree-toggler-icon"
            />
          } @else {
            <standard-icon
              [icon]="faChevronDown"
              styleClass="p-tree-toggler-icon"
            />
          }
        } @else if (loadingMode === "icon") {
          <standard-icon
            [icon]="faCircleNotch"
            styleClass="pi-spin p-tree-node-toggler-icon"
          />
        }
      } @else {
        <span class="p-tree-toggler-icon">
          <ng-template
            *ngTemplateOutlet="
              tree.togglerIconTemplate();
              context: { $implicit: node.expanded }
            "
          />
        </span>
      }
    </button>

    @if (tree.selectionMode() == "checkbox") {
      <div
        class="p-checkbox p-component"
        [class.p-checkbox-disabled]="isSelectionDisabled"
        [class.p-disabled]="isSelectionDisabled"
        [class.p-variant-filled]="tree.config.inputStyle() === 'filled'"
        aria-hidden="true"
      >
        <div
          class="p-checkbox-box"
          [class.p-highlight]="isSelected"
          [class.p-indeterminate]="node.partialSelected"
          role="checkbox"
          [attr.aria-checked]="isSelected"
        >
          @if (!tree.checkboxIconTemplate()) {
            @if (!node.partialSelected && isSelected) {
              <standard-icon [icon]="faCheck" styleClass="p-checkbox-icon" />
            } @else if (node.partialSelected) {
              <standard-icon [icon]="faMinus" styleClass="p-checkbox-icon" />
            }
          } @else {
            <ng-template
              *ngTemplateOutlet="
                tree.checkboxIconTemplate();
                context: {
                  $implicit: isSelected,
                  partialSelected: node.partialSelected,
                }
              "
            />
          }
        </div>
      </div>
    }

    @if (node.icon || node.expandedIcon || node.collapsedIcon) {
      <span [class]="iconClasses()"></span>
    }

    <span class="p-treenode-label">
      @if (!templateForNode) {
        <span>{{ node.label }}</span>
      } @else {
        <span>
          <ng-container
            *ngTemplateOutlet="templateForNode; context: { $implicit: node }"
          />
        </span>
      }
    </span>
  </div>
  @if (!tree.virtualScroll() && node.children && node.expanded) {
    <ul
      class="p-treenode-children"
      [style.display]="node.expanded ? 'block' : 'none'"
      role="group"
    >
      @for (
        childNode of node.children;
        track tree.trackBy(index, childNode);
        let firstChild = $first;
        let lastChild = $last;
        let index = $index
      ) {
        <p-treeNode
          [node]="childNode"
          [parentNode]="node"
          [firstChild]="firstChild"
          [lastChild]="lastChild"
          [index]="index"
          [parentItemSize]="parentItemSize"
          [childItemSize]="childItemSize"
          [level]="(level ?? 0) + 1"
          [loadingMode]="loadingMode"
        />
      }
    </ul>
  }

  @if (draghoverNext() && canShowDropPointBetween()) {
    <span
      class="p-treenode-droppoint-dot p-treenode-droppoint-dot-start"
    ></span>
    <span class="p-treenode-droppoint-dot p-treenode-droppoint-dot-end"></span>
  }
</li>
